import React from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import welcomeImg from '../../assets/nuevas-localidades.jpeg';

const overlayStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  outline: 'none',
  maxWidth: '90vw',
  maxHeight: '90vh',
};

export default function WelcomeModal({ open, onClose }) {
  return (
    <Modal
      open={open}
      onClose={null}
      disableEscapeKeyDown
      aria-labelledby="welcome-modal"
    >
      <Box sx={overlayStyle}>
        <IconButton
          style={{ position: 'absolute', textAlign: 'left', display: 'inline-block', left: 0, width: 50, height: 50, background: '#fff', color: '#333' }}
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            zIndex: 1,
            bgcolor: 'rgba(0,0,0,0.5)',
            color: '#fff',
            '&:hover': { bgcolor: 'rgba(0,0,0,0.75)' },
          }}
        >
          <CloseIcon />
        </IconButton>
        <img
          src={welcomeImg}
          alt="Bienvenida"
          style={{ display: 'block', maxWidth: '90vw', maxHeight: '70vh', borderRadius: 8 }}
        />
      </Box>
    </Modal>
  );
}
